import { useMutation, useQueryClient } from "@tanstack/react-query";
import { serviceMapService } from "../../../services/serviceMapService";
import { businessServiceService } from "../../../services/businessServiceService";

export const useSystemAddDependency = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceMapId,
      systemId,
      dependencies,
    }: {
      serviceMapId: string;
      systemId: string;
      dependencies: string[];
    }) => {
      if (dependencies.length === 0) {
        return serviceMapId;
      }
      const r = await businessServiceService.addDependencies(
        serviceMapId,
        systemId,
        dependencies,
      );
      await serviceMapService.updateServiceStatuses(r);
      return r;
    },
    onSuccess: (serviceMapId) => {
      qc.invalidateQueries({ queryKey: ["serviceMapId", serviceMapId] });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
